import * as React from "react";
//MUI COMPONENTS
import {
  Switch,
  FormHelperText,
  Box,
  Stepper,
  Step,
  StepLabel,
  Button,
  Typography,
  TextField,
  InputLabel,
  Select,
  MenuItem,
  FormControl,
} from "@mui/material";
//STYLES
import styles from "../../../module_css/formsCatalogs.module.css";
import ApiController from "../../../controllers/api";
import Swal from "sweetalert2";
import CustomBackdrop from "../../CustomBackdrop";
import { ArrowForward, Done, Info, Queue } from "@mui/icons-material";

//PICTURES
import imgUpdate from "../../../assets/svg/update.svg";

const ERROR_MESSAGES = {
  //MENSAJES DE ERROR
  required: "EL CAMPO ES OBLIGATORIO",
  invalid: "EL VALOR DEL CAMPO NO CUMPLE CON EL FORMATO",
  minLength: "EL VALOR DEL CAMPO ES DEMASIADO CORTO",
  maxLength: "EL VALOR DEL CAMPO ES DEMASIADO LARGO",
};
const PROPERTIES_ENTRIES = {
  costo: {
    required: true,
    pattern: /^\d+(\.\d{1,3})?$/,
    minLength: 7,
    maxLength: 20,
  },
  marca: {
    required: true,
    pattern: /^[A-ZÁÉÍÓÚÑ0-9\s\.-]+$/,
    minLength: 5,
    maxLength: 80,
  },
  modelo: {
    required: true,
    pattern: /^[A-ZÁÉÍÓÚÑ0-9\s\.-]+$/,
    minLength: 5,
    maxLength: 80,
  },
  noSerie: {
    required: true,
    pattern: /^[A-Z0-9\-\.]+$/,
    minLength: 5,
    maxLength: 80,
  },
  noFactura: {
    required: true,
    pattern: /^[A-Z0-9]+$/,
    minLength: 5,
    maxLength: 80,
  },
  fechaAdquisicion: {
    required: true,
    pattern: /^(19|20)\d\d-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/,
  },
  noPoliza: {
    required: true,
    pattern: /^[A-Z0-9\.-]+$/,
    minLength: 5,
    maxLength: 80,
  },
  noInvAnterior: {
    required: true,
    pattern: /^[A-Z0-9\.-]+$/,
    minLength: 5,
    maxLength: 50,
  },
  proveedor: {
    required: true,
    pattern: /^[A-ZÁÉÍÓÚÑ0-9\s\.-]+$/,
    minLength: 10,
    maxLength: 100,
  },
  observaciones: {
    required: true,
    pattern: /^[A-ZÁÉÍÓÚÑ0-9\s.,;:!¿?()"'\/\-]+$/,
    minLength: 10,
    maxLength: 100,
  },
  foto: {
    required: true,
  },
  estadoFisico: {
    required: true,
  },
  descripcionFisica: {
    required: true,
    pattern: /^[A-ZÁÉÍÓÚÑ0-9\s,.\-()/]+$/,
    minLength: 10,
    maxLength: 100,
  },
};

const hoy = new Date();
const fechaHoy = `${hoy.getFullYear()}-${String(hoy.getMonth() + 1).padStart(2, "0")}-${String(hoy.getDate()).padStart(2, "0")}`;

export default function FormEditInventory({
  id = null,
  handleClose,
  refreshArea,
}) {
  const steps = [
    //ENCABEZADOS DE STEPPER
    "DATOS ADICIONALES",
  ];
  const stepperRef = React.useRef(null);
  const stepRefs = React.useRef([]);
  const [openBackdrop, setOpenBackdrop] = React.useState(false); //* = ESTADO PARA CONTROLAR EL BACKDROP
  const [dataGet, setDataGet] = React.useState({
    //* - ESTADO PARA GUARDAR DATOS CONSTANTES DE LOS SELECT
    ESTADO_FISICO: [],
  });
  const [data, setData] = React.useState({
    //* - ESTADO DATOS VALUES
    costo: null,
    marca: "",
    modelo: "",
    noSerie: "",
    estadoFisico: null,
    noFactura: "",
    fechaAdquisicion: null,
    noPoliza: "",
    noInvAnterior: null,
    proveedor: "",
    descripcionFisica: "",
    observaciones: "",
    foto: "",
  });
  const [dataNot, setDataNot] = React.useState({
    area: "",
    edificio: "",
    partida: "",
    bien: "",
    codigo: "",
    foto: "",
  });
  const [controllSwitch, setControllSwitch] = React.useState({
    costo: true,
    marca: true,
    modelo: true,
    noSerie: true,
    noFactura: true,
    fechaAdquisicion: true,
    noPoliza: true,
    noInvAnterior: true,
    proveedor: true,
    observaciones: true,
  });

  const fields = [
    {
      name: "costo",
      label: "COSTO",
      description: "¿EL BIEN TIENE COSTO?",
      type: "number",
    },
    {
      name: "marca",
      label: "MARCA",
      description: "¿EL BIEN TIENE MARCA?",
      type: "text",
    },
    {
      name: "modelo",
      label: "MODELO",
      description: "¿EL BIEN TIENE MODELO?",
      type: "text",
    },
    {
      name: "noSerie",
      label: "NÚMERO DE SERIE",
      description: "¿EL BIEN TIENE NÚMERO DE SERIE?",
      type: "text",
    },
    {
      name: "noFactura",
      label: "NÚMERO DE FACTURA",
      description: "¿EXISTE UNA FACTURA ASOCIADA?",
      type: "text",
    },
    {
      name: "fechaAdquisicion",
      label: "FECHA DE ADQUISICIÓN",
      description: "¿EL BIEN TIENE FECHA DE ADQUISICIÓN?",
      type: "date",
    },
    {
      name: "noPoliza",
      label: "NÚMERO DE PÓLIZA",
      description: "¿EL BIEN TIENE NÚMERO DE PÓLIZA?",
      type: "text",
    },
    {
      name: "noInvAnterior",
      label: "NÚMERO DE INVENTARIO ANTERIOR",
      description: "¿EXISTE UN NÚMERO DE INVENTARIO ANTERIOR?",
      type: "text",
    },
    {
      name: "proveedor",
      label: "PROVEEDOR",
      description: "¿EL BIEN TIENE PROVEEDOR?",
      type: "text",
    },
    {
      name: "observaciones",
      label: "OBSERVACIONES",
      description: "¿EL BIEN TIENE OBSERVACIONES?",
      type: "text",
    },
  ];
  
  //* - ESTADO ERRORES
  const [errors, setErrors] = React.useState({
    costo: [],
    marca: [],
    modelo: [],
    noSerie: [],
    estadoFisico: [],
    noFactura: [],
    fechaAdquisicion: [],
    noPoliza: [],
    noInvAnterior: [],
    proveedor: [],
    descripcionFisica: [],
    observaciones: [],
  });

  const [activeStep, setActiveStep] = React.useState(0); //* - ESTADO PARA CONTROLAR EL STEPPER

  const apiInstance = React.useMemo(
    () => new ApiController(process.env.REACT_APP_API_URL),
    [],
  );

  const getData = async (id) => await apiInstance.get(`/inventory/${id}`);
  const updateData = async (data) => await apiInstance.put(`/inventory/${id}`, data);
  const formatDate = (isoString) => isoString.slice(0, 10);

  React.useEffect(() => {
    (async () => {
      setOpenBackdrop(true);
      const response = await getData(id);
      if (response.success) {
        setDataGet((prev) => ({
          ...prev,
          ESTADO_FISICO: response.data.ESTADO_FISICO || [],
        }));
        const info = response.data.INFO;
        setData({
          costo: info.COSTO,
          marca: info.MARCA,
          modelo: info.MODELO,
          noSerie: info.SERIE,
          noFactura: info.FACTURA,
          fechaAdquisicion: info.FECHA ? formatDate(info.FECHA) : null,
          noPoliza: info.POLIZA,
          noInvAnterior: info.INVENTARIO_ANTERIOR,
          proveedor: info.PROVEEDOR,
          observaciones: info.OBSERVACIONES,
          descripcionFisica: info.DESCRIPCION,
          estadoFisico: info.ESTADO,
        });
        setDataNot({
          area: info.AREA,
          edificio: info.EDIFICIO,
          partida: info.PARTIDA,
          bien: info.BIEN,
          codigo: info.CODIGO,
          foto: info.IMAGEN,
        });
        setControllSwitch((prev) => {
          const mapping = {
            costo: "COSTO",
            marca: "MARCA",
            modelo: "MODELO",
            noSerie: "SERIE",
            noFactura: "FACTURA",
            fechaAdquisicion: "FECHA",
            noPoliza: "POLIZA",
            noInvAnterior: "INVENTARIO_ANTERIOR",
            proveedor: "PROVEEDOR",
            observaciones: "OBSERVACIONES",
          };
          const updated = { ...prev };
          for (const key in mapping) {
            const infoKey = mapping[key];
            updated[key] =
              info[infoKey] !== null && info[infoKey] !== undefined;
          }
          return updated;
        });
      } else if (!response.success) {
        Swal.fire({
          title: "¡ERROR! ❌",
          icon: "error",
          text: "NO SE PUDIERON CARGAR LOS DATOS",
          showConfirmButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
          confirmButtonColor: "#ef7474",
          confirmButtonText: "CONFIRMAR",
          padding: "0 0 20px",
        });
        handleClose();
      }
      setOpenBackdrop(false);
    })();
  }, []);

  React.useEffect(() => { //* CENTRAR EL HEADER DEL STEPPER EN CADA PASO
    if (stepRefs.current[activeStep] && stepperRef.current) {
      const stepNode = stepRefs.current[activeStep];
      const stepperNode = stepperRef.current;
      const stepLeft = stepNode.offsetLeft;
      const stepWidth = stepNode.offsetWidth;
      const stepperWidth = stepperNode.offsetWidth;
      const scrollTo = stepLeft - stepperWidth / 2 + stepWidth / 2;
      stepperNode.scrollTo({
        left: scrollTo,
        behavior: "smooth",
      });
    }
  }, [activeStep]);

  const validateFieldGeneric = (value, options = {}, switchState = true) => {//* VALIDAR POR CAMPO UNITARIO
    const errors = [];
    if (options.required && switchState && !value)
      errors.push({ type: "required" });
    if (value && options.pattern && !options.pattern.test(value))
      errors.push({ type: "invalid" });
    if (value && options.minLength && value.length < options.minLength)
      errors.push({ type: "minLength" });
    if (value && options.maxLength && value.length > options.maxLength)
      errors.push({ type: "maxLength" });
    return errors;
  };

  const validateAllFields = (fieldsToValidate) => {
    //RECORRER CADA VALIDACION
    const newErrors = {};
    for (const field of fieldsToValidate) {
      const isEnabled =
        controllSwitch[field] !== undefined ? controllSwitch[field] : true;
      newErrors[field] = validateFieldGeneric(
        data[field],
        PROPERTIES_ENTRIES[field],
        isEnabled,
      );
    }
    setErrors((prev) => ({ ...prev, ...newErrors }));
    return !Object.values(newErrors).some(
      (fieldErrors) => fieldErrors.length > 0,
    );
  };

  const getHelperText = (field) => {
    //AGREGAR MENSAJES DE ERROR
    return (
      errors[field].map((e) => "- *" + ERROR_MESSAGES[e.type]).join("\n") || ""
    );
  };

  const stepHasError = (step) => {
    //ERRORES EN EL STEPPER
    let fieldsToCheck = [];
    switch (step) {
      case 0:
        fieldsToCheck = [
          "costo",
          "marca",
          "modelo",
          "noSerie",
          "estadoFisico",
          "noFactura",
          "fechaAdquisicion",
          "noPoliza",
          "noInvAnterior",
          "proveedor",
          "descripcionFisica",
          "observaciones",
        ];
        break;
      default:
        fieldsToCheck = [];
        break;
    }
    return fieldsToCheck.some((field) => errors[field]?.length > 0);
  };

  const handleControllSwitch = (e) => {
    const { name, checked } = e.target;
    setControllSwitch((prev) => ({
      ...prev,
      [name]: checked,
    }));
    if (!checked) {
      setData((prev) => ({ ...prev, [name]: null }));
      setErrors((prev) => ({ ...prev, [name]: [] }));
    } else setData((prev) => ({ ...prev, [name]: "" }));
  };

  const handleChange = async (e) => {
    const { name, value } = e.target;
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleNext = () => {
    let fieldsToValidate = []; //VALIDAR SOLO ESAS ENTRADAS
    switch (activeStep) {
      case 0:
        fieldsToValidate = [
          "costo",
          "marca",
          "modelo",
          "noSerie",
          "estadoFisico",
          "noFactura",
          "fechaAdquisicion",
          "noPoliza",
          "noInvAnterior",
          "proveedor",
          "descripcionFisica",
          "observaciones",
        ];
        break;
      default:
        fieldsToValidate = [];
        break;
    }
    if (!validateAllFields(fieldsToValidate)) return; //SI HAY ERRORES NO AVANZA
    setActiveStep((prev) => prev + 1); //AVANZAR AL SIGUIENTE PASO
  };

  const handleBack = () => setActiveStep((prev) => prev - 1); //REGRESAR AL PASO ANTERIOR

  const handleReset = () => {
    setActiveStep(0);
    setData({
      costo: null,
      marca: "",
      modelo: "",
      noSerie: "",
      estadoFisico: null,
      noFactura: "",
      fechaAdquisicion: null,
      noPoliza: "",
      noInvAnterior: "",
      proveedor: "",
      descripcionFisica: "",
      observaciones: "",
    });
    setErrors({
      costo: [],
      marca: [],
      modelo: [],
      noSerie: [],
      estadoFisico: [],
      noFactura: [],
      fechaAdquisicion: [],
      noPoliza: [],
      noInvAnterior: [],
      proveedor: [],
      descripcionFisica: [],
      observaciones: [],
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const invalidFields = Object.keys(PROPERTIES_ENTRIES).filter(
      (field) => !validateAllFields(field),
    );

    if (invalidFields.length > 0) {
      setActiveStep(0);
      return;
    }

    Swal.fire({
      title: "ACTUALIZAR ESTE INVENTARIO ⚠️",
      text: "¿ESTAS SEGURO DE ACTUALIZAR ESTE BIEN?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "SI, ACTUALIZAR",
      confirmButtonColor: "#1b76d3",
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setOpenBackdrop(true);
        const formData = new FormData(); //FORMDATA PARA ENVIO
        for (const key in data) {
          if (
            [
              "costo",
              "marca",
              "modelo",
              "noSerie",
              "noFactura",
              "fechaAdquisicion",
              "noPoliza",
              "noInvAnterior",
              "proveedor",
              "observaciones",
            ].includes(key) &&
            data[key] === null
          )
            formData.append(key, "null");
          else if (data[key] !== null && data[key] !== undefined)
            formData.append(key, data[key]);
        }
        const res = await updateData(formData); //CUERPO DE LA CARGA UTIL
        if (res.success) {
          Swal.mixin({
            toast: true,
            position: "bottom-start",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          }).fire({
            icon: "success",
            title: "BIEN ACTUALIZADO EN EL INVENTARIO",
            text: "SE ACTUALIZO CORRECTAMENTE",
          });
          if (refreshArea) refreshArea();
        } else {
          Swal.fire({
            title: "¡ERROR! ❌",
            icon: "error",
            text: "NO SE PUDO AGREGAR ESTE BIEN AL INVENTARIO",
            showConfirmButton: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            confirmButtonColor: "#ef7474",
            confirmButtonText: "CONFIRMAR",
            padding: "0 0 20px",
          });
        }
        setOpenBackdrop(false);
        handleClose();
      }
    });
  };

  const renderStepContent = (step) => {
    //RENDER DE CADA PASO
    switch (step) {
      case 0:
        return (
          <>
            <Box
              sx={{
                m: "20px auto",
                width: "300px",
                height: "150px",
                border: "2px dashed",
                borderColor: "#e0dfdfff",
                borderRadius: 2,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                overflow: "hidden",
                backgroundColor: "#ededed",
              }}
            >
              <img
                src={dataNot.foto}
                alt="preview"
                style={{ maxWidth: "100%", maxHeight: "100%" }}
              />
            </Box>
            <TextField
              label="PARTIDA DESIGNADA"
              variant="outlined"
              autoComplete="off"
              fullWidth
              className={styles.textField_form}
              value={dataNot.partida}
              disabled={true}
              InputLabelProps={{ shrink: true }}
              helperText="-ESTE VALOR NO PUEDE SER MODIFICADO"
            />
            <TextField
              label="EDIFICIO DESIGNADO"
              variant="outlined"
              autoComplete="off"
              fullWidth
              className={styles.textField_form}
              value={dataNot.edificio}
              disabled={true}
              InputLabelProps={{ shrink: true }}
              helperText="-ESTE VALOR NO PUEDE SER MODIFICADO"
            />
            <TextField
              label="AREÁ DESIGNADA"
              variant="outlined"
              autoComplete="off"
              fullWidth
              className={styles.textField_form}
              value={dataNot.area}
              disabled={true}
              InputLabelProps={{ shrink: true }}
              helperText="-ESTE VALOR NO PUEDE SER MODIFICADO"
            />
            <TextField
              label="BIEN DESIGNADO"
              variant="outlined"
              autoComplete="off"
              fullWidth
              className={styles.textField_form}
              value={dataNot.bien}
              disabled={true}
              InputLabelProps={{ shrink: true }}
              helperText="-ESTE VALOR NO PUEDE SER MODIFICADO"
            />
            <Box display="flex" flexDirection="column" gap={2}>
              {fields.map((field) => {
                const isDate = field.type === "date";
                return (
                  <Box
                    key={field.name}
                    display="flex"
                    flexDirection="column"
                    sx={{
                      border: "1px solid",
                      borderColor: "divider",
                      borderRadius: 1,
                      p: 1.5,
                      bgcolor: "background.paper",
                    }}
                  >
                    <Box display="flex" alignItems="center" gap={1}>
                      {/* NO */}
                      <Typography
                        variant="caption"
                        fontWeight={
                          !controllSwitch[field.name] ? "bold" : "normal"
                        }
                        color={
                          !controllSwitch[field.name]
                            ? "text.primary"
                            : "text.disabled"
                        }
                      >
                        NO
                      </Typography>

                      {/* SWITCH */}
                      <Switch
                        name={field.name}
                        checked={controllSwitch[field.name]}
                        onChange={handleControllSwitch}
                        color="primary"
                        size="small"
                      />

                      {/* SI */}
                      <Typography
                        variant="caption"
                        fontWeight={
                          controllSwitch[field.name] ? "bold" : "normal"
                        }
                        color={
                          controllSwitch[field.name]
                            ? "primary.main"
                            : "text.disabled"
                        }
                      >
                        SI
                      </Typography>

                      {/* DESCRIPCIÓN DEL CAMPO */}
                      <Typography variant="caption" sx={{ ml: 1 }}>
                        {field.description}
                      </Typography>
                    </Box>

                    <TextField
                      label={field.label}
                      variant="outlined"
                      autoComplete="off"
                      fullWidth
                      className={styles.textField_form}
                      name={field.name}
                      type={field.type || "text"}
                      value={
                        controllSwitch[field.name] ? data[field.name] || "" : ""
                      }
                      onChange={handleChange}
                      error={errors[field.name]?.length > 0}
                      helperText={getHelperText(field.name)}
                      sx={{
                        "& .MuiFormHelperText-root": { whiteSpace: "pre-line" },
                      }}
                      disabled={!controllSwitch[field.name]}
                      {...(isDate && {
                        InputLabelProps: { shrink: true },
                        inputProps: { max: fechaHoy },
                      })}
                    />
                  </Box>
                );
              })}
            </Box>
            <TextField
              label="DESCRIPCIÓN FÍSICA"
              variant="outlined"
              multiline
              rows={3}
              autoComplete="off"
              fullWidth
              className={styles.textField_form}
              name="descripcionFisica"
              value={data.descripcionFisica}
              onChange={handleChange}
              error={errors.descripcionFisica.length > 0}
              helperText={getHelperText("descripcionFisica")}
              sx={{ "& .MuiFormHelperText-root": { whiteSpace: "pre-line" } }}
            />
            <FormControl
              variant="outlined"
              sx={{ mt: 1, mb: 1 }}
              fullWidth
              error={errors.estadoFisico.length > 0}
            >
              <InputLabel id="estado-label">ESTADO FISICO</InputLabel>
              <Select
                labelId="estado-label"
                id="estado-select"
                name="estadoFisico"
                value={data.estadoFisico ?? ""}
                onChange={handleChange}
                label="ESTADO FISICO"
              >
                {Object.entries(dataGet.ESTADO_FISICO || {}).map(
                  ([key, value]) => (
                    <MenuItem key={key} value={key}>
                      {value}
                    </MenuItem>
                  ),
                )}
              </Select>
              {errors.estadoFisico.length > 0 && (
                <FormHelperText sx={{ whiteSpace: "pre-line" }}>
                  {getHelperText("estadoFisico")}
                </FormHelperText>
              )}
            </FormControl>
          </>
        );
      default:
        return "Paso no encontrado";
    }
  };

  return (
    <>
      <CustomBackdrop open={openBackdrop} />
      <form className={styles.container_main_form} onSubmit={handleSubmit}>
        <Box
          ref={stepperRef}
          sx={{
            mt: 3,
            mb: 2,
            width: "100%",
            overflowX: "auto",
            scrollbarWidth: "none",
            "&::-webkit-scrollbar": { display: "none" },
          }}
        >
          <Stepper
            activeStep={activeStep}
            alternativeLabel
            sx={{ width: "100%" }}
          >
            {steps.map((label, index) => (
              <Step key={label} ref={(el) => (stepRefs.current[index] = el)}>
                <StepLabel error={stepHasError(index)}>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </Box>
        <img src={imgUpdate} alt="Logo" className={styles.logo_form} />
        <Typography variant="subtitle2" gutterBottom align="center">
          <b>{dataNot.codigo}</b>
        </Typography>
        <Typography variant="h7" gutterBottom align="center">
          ACTUALIZAR INFORMACIÓN DEL INVENTARIO DE ESTE BIEN
        </Typography>

        <div>
          {activeStep === steps.length ? (
            <Box textAlign="center">
              <Typography variant="subtittle1">
                ¡¡EL FORMULARIO ESTA LISTO PARA SER ENVIADO!!
              </Typography>
              <Button
                variant="contained"
                color="primary"
                startIcon={<Queue />}
                type="submit"
                fullWidth
              >
                ACTUALIZAR
              </Button>
              <Button onClick={handleReset} sx={{ ml: 2 }}>
                REINICIAR
              </Button>
            </Box>
          ) : (
            <Box>
              <Box mt={3} mb={2}>
                {renderStepContent(activeStep)}
              </Box>
              <Box display="flex" justifyContent="space-between">
                {activeStep !== 0 ? (
                  <Button onClick={handleBack}>ATRAS</Button>
                ) : (
                  <div /> //GUARDAR ESPACIO
                )}
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleNext}
                  fullWidth
                  endIcon={
                    activeStep === steps.length - 1 ? (
                      <Done />
                    ) : (
                      <ArrowForward />
                    )
                  }
                >
                  {activeStep === steps.length - 1 ? "FINALIZAR" : "SIGUIENTE"}
                </Button>
              </Box>
            </Box>
          )}
        </div>
      </form>
    </>
  );
}
